import { CHILEAN_COMUNAS } from "~/constants/places";

/**
 * Normalizes a comuna string to its canonical Chilean comuna name.
 * Handles: snake_case values, case variations, missing accents.
 * Returns the original value if no match (foreign addresses).
 */
export function normalizeComuna(
  input: string | null | undefined
): string | null {
  if (!input) return null;

  const trimmed = input.trim();

  // Check if already canonical (exact match)
  const exactCanonical = CHILEAN_COMUNAS.find((c) => c.label === trimmed);
  if (exactCanonical) return trimmed;

  // Check if it's a snake_case value
  const byValue = CHILEAN_COMUNAS.find((c) => c.value === trimmed);
  if (byValue) return byValue.label;

  // Check case-insensitive match on label
  const byLabelLower = CHILEAN_COMUNAS.find(
    (c) => c.label.toLowerCase() === trimmed.toLowerCase()
  );
  if (byLabelLower) return byLabelLower.label;

  // Check case-insensitive match on value (handles lowercase snake_case)
  const byValueLower = CHILEAN_COMUNAS.find(
    (c) => c.value.toLowerCase() === trimmed.toLowerCase()
  );
  if (byValueLower) return byValueLower.label;

  // Handle common variations without accents
  const normalized = trimmed
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, ""); // Remove accents for comparison

  const byNormalized = CHILEAN_COMUNAS.find((c) => {
    const labelNorm = c.label
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    return labelNorm === normalized;
  });
  if (byNormalized) return byNormalized.label;

  // No match - return original (could be foreign address)
  return trimmed;
}
